import { createApi } from '@reduxjs/toolkit/query/react'
import { createBffApiBaseQuery } from './apiClients'

export const donateVariantsApi = createApi({
    reducerPath: 'donateVariantsApi',
    baseQuery: createBffApiBaseQuery('donateVariantsApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/donate-variants` }),
    tagTypes: ['DonateVariants', 'DonateVariantsByUsername', 'DonateVariant', 'DonateVariantByUsername'],
    endpoints: (builder) => ({
        getDonateVariants: builder.query({
            query: () => {
                return {
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['DonateVariants']
        }),
        getDonateVariantsByUsername: builder.query({
            query: (args) => {
                return {
                    url: `/enabled?username=${args.username}`,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['DonateVariantsByUsername']
        }),
        getDonateVariant: builder.query({
            query: (type) => {
                return {
                    url: `/${type}`,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['DonateVariant']
        }),
        getDonateVariantByUsername: builder.query({
            query: (args) => {
                return {
                    url: `/${args.type}?username=${args.username}`,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['DonateVariantByUsername']
        }),
        createDonateVariant: builder.mutation({
            query: (body) => {
                return {
                    method: 'POST',
                    body: body
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            invalidatesTags: ['DonateVariants', 'DonateVariant', 'DonateVariantByUsername', 'DonateVariantsByUsername']
        }),
        updateDonateVariant: builder.mutation({
            query: (body) => {
                return {
                    url: `/${body.id}`,
                    method: 'PUT',
                    body: body
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            invalidatesTags: ['DonateVariants', 'DonateVariant', 'DonateVariantByUsername', 'DonateVariantsByUsername']
        }),
        deleteDonateVariant: builder.mutation({
            query: (id) => {
                return {
                    url: `/${id}`,
                    method: 'DELETE'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            invalidatesTags: ['DonateVariants', 'DonateVariant', 'DonateVariantByUsername', 'DonateVariantsByUsername']
        }),
    }),
})

export const { 
    useGetDonateVariantsQuery,
    useGetDonateVariantsByUsernameQuery,
    useGetDonateVariantQuery,
    useGetDonateVariantByUsernameQuery,
    useCreateDonateVariantMutation, 
    useUpdateDonateVariantMutation, 
    useDeleteDonateVariantMutation 
} = donateVariantsApi
